import React from 'react';
import styles from './skeleton.module.css';

export const Skeleton = ({ mini = false, hero = false }: { mini?: boolean; hero?: boolean }) => {
  if (hero) {
    return <></>;
  }

  return (
    <div className={styles.wrapper}>
      <div className={`${styles.container} ${styles.formSectionContainer}`}>
        <div className={styles.section}>
          <div className={`${styles.contentLine} ${styles.contentLine50}`}></div>
          <div className={styles.contentLine}></div>
          {!mini && (
            <>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
              <div className={styles.contentLine}></div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
